module.exports = __webpack_public_path__ + "img/ios_default.7a0445ae.png";